var map = {
	"./mijnstad-gemeente_de.svg": 21561,
	"./mijnstad-gemeente_en.svg": 49361,
	"./mijnstad-gemeente_fr.svg": 39472,
	"./mijnstad-gemeente_nl.svg": 99550
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50022;